currentCanonizeResults